import Button from "@mui/material/Button";
import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import SpinningIcon from "../../../../components/SpinningIcon";
import { Toast } from "../../../../components/Toast";

export default function SmartAssetsGenerationButton() {
  const [isLoading, setIsLoading] = useState(false);
  const { generateSmartAsset } = useAPI();

  const handleOnClick = () => {
    setIsLoading(true);
    generateSmartAsset()
      .then(() => {
        setIsLoading(false);
        Toast.success("Finished generating smart assets");
      })
      .catch(() => {
        setIsLoading(false);
        Toast.error("Failed to generate smart assets");
      });
  };

  return (
    <Button
      variant="outlined"
      sx={{
        backgroundColor: "pink",
      }}
      onClick={handleOnClick}
    >
      <SpinningIcon isLoading={isLoading} />
      <span style={{ marginLeft: "8px" }}>Generate Smart-Assets</span>
    </Button>
  );
}
